import type { SettlementSummaryClosure } from "@/lib/data/requests/reports/reports-settlement-summary";

export function ClosureChart({
  points,
}: {
  points: SettlementSummaryClosure[];
}) {
  const width = 700;
  const top = 28;
  const bottom = 255;
  const left = 40;
  const ceiling = Math.ceil(Math.max(1, ...points.map((p) => p.count)) / 4) * 4;
  const step = (width - left - 16) / Math.max(1, points.length);
  const labelEvery = Math.max(1, Math.ceil(points.length / 10));
  const monthly =
    points.length < 2 ||
    Date.parse(points[1].date) - Date.parse(points[0].date) > 14 * 86_400_000;
  const label = (date: string) =>
    new Date(`${date}T12:00:00`).toLocaleDateString(undefined, {
      month: "short",
      day: monthly ? undefined : "numeric",
      year: monthly ? "numeric" : undefined,
    });
  return (
    <figure>
      <svg
        viewBox={`0 0 ${width} 310`}
        className="w-full"
        role="img"
        aria-label="Closed matters in the selected date range"
      >
        <title>Closed matters</title>
        <desc>{points.map((p) => `${p.date}: ${p.count}`).join("; ")}</desc>
        {[0, 1, 2, 3, 4].map((n) => {
          const y = bottom - (n / 4) * (bottom - top);
          return (
            <g key={n}>
              <line
                x1={left}
                x2={width - 16}
                y1={y}
                y2={y}
                className="stroke-border"
              />
              <text
                x={left - 8}
                y={y + 4}
                textAnchor="end"
                className="fill-muted-foreground text-xs"
              >
                {(ceiling * n) / 4}
              </text>
            </g>
          );
        })}
        {points.map((p, n) => {
          const barHeight = (p.count / ceiling) * (bottom - top);
          const x = left + n * step + step * 0.15;
          return (
            <g key={p.date}>
              <rect
                x={x}
                y={bottom - barHeight}
                width={step * 0.7}
                height={barHeight}
                rx={2}
                className="fill-primary"
              >
                <title>
                  {label(p.date)}: {p.count} closed matters
                </title>
              </rect>
              {n % labelEvery === 0 && (
                <text
                  x={x + step * 0.35}
                  y={bottom + 26}
                  textAnchor="middle"
                  className="fill-muted-foreground text-xs"
                >
                  {label(p.date)}
                </text>
              )}
            </g>
          );
        })}
      </svg>
    </figure>
  );
}
